// This file is auto-generated, any changes you make may be overridden
// You should use src/mercuryWebCompat/pages/Treasury/Onboarding/utils.ts to access these values
import {type GeneratedCusip, type TreasuryOnboardingData} from './types'
import {Day} from '~/utils/Calendar'

export const generatedPortfolioData: Record<
  GeneratedCusip | '4812C2734',
  TreasuryOnboardingData
> = {
  // Morgan Stanley MULSX
  '617455696': {
    fundSize: `$14.8B`,
    maturity: `86 days`,
    netYieldPct: 3.534,
    grossYieldPct: 4.4,
    mercuryFeePct: 0.866,
    composition: [
      ['Commercial Paper', 38.45],
      ['Corporate Notes', 29.06],
      ['Repurchase Agreements', 19.0],
      ['Certificates of Deposit', 13.49],
    ],
    updatedAt: new Day(2025, 8, 18),
  },
  // Vanguard VUSXX
  '921932109': {
    fundSize: `$95.3 B`,
    maturity: `40 days`,
    netYieldPct: 3.374,
    grossYieldPct: 4.24,
    mercuryFeePct: 0.866,
    composition: [
      ['U.S. Treasury Bills', 89.4],
      ['Repurchase Agreements', 6.4],
      ['U.S. Govt. Obligations', 4.2],
    ],
    updatedAt: new Day(2025, 8, 18),
  },
  // JPMorgan IJTXX
  '4812C2734': {
    fundSize: `$49.94B`,
    maturity: `51 days`,
    netYieldPct: 3.354,
    grossYieldPct: 4.22,
    mercuryFeePct: 0.866,
    composition: [
      ['U.S. Treasury Debt', 50.5],
      ['U.S. Treasury Repurchase Agreement', 49.5],
    ],
    updatedAt: new Day(2025, 8, 18),
  },
} as const
